import React from 'react';
import {PageCounterStyle} from './PageCounter.styled';

export default function PageCounter({dataPerPageCounter, active}) {

  return (
    <PageCounterStyle className={!active && "Inactive"}>
        <select onClick={(e) => dataPerPageCounter(e.target.value)} >
            <option value="5">5</option>
            <option value="10">10</option>     
        </select>
    </PageCounterStyle>
  )
}